// extracted by mini-css-extract-plugin
module.exports = {"TextLink":"TextLink_TextLink__gpFQo"};